module.exports = __webpack_public_path__ + "static/media/Cluster-3_video.b11af815.mp4";